import { TextBoxToolbarProps } from './Types'
import { track } from '@tldraw/tldraw'
import { Toolbar } from '../ContextToolbar/Toolbar'
import { CopyButton } from '../components/CopyButton/CopyButton'
import { DeleteButton } from '../components/DeleteButton/DeleteButton'
import { MoreOptionsButton } from '../components/MoreOptionsButton/MoreOptionsButton'
import { MobileTextEditButton } from '../components/MobileTextEditButton/MobileTextEditButton'
import { DesktopTextEditButton } from '../components/DesktopTextEditButton/DesktopTextEditButton'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'

const TextBoxToolbar = track(({ editor, shapeId }: TextBoxToolbarProps) => {
  const shape = editor.getShape(shapeId)

  return (
    <Toolbar>
      <ResponsiveDesign.Desktop>
        <DesktopTextEditButton editor={editor} />
      </ResponsiveDesign.Desktop>
      <ResponsiveDesign.Mobile>
        <MobileTextEditButton editor={editor} />
      </ResponsiveDesign.Mobile>

      <CopyButton />
      <DeleteButton />
      <MoreOptionsButton selectedShape={shape} />
    </Toolbar>
  )
})

export { TextBoxToolbar }
